var map = {
	"./1_en.png": "3c70",
	"./2_no.png": "8d4f",
	"./3_se.png": "c9c3",
	"./4_dk.png": "eaf1",
	"./5_fr.png": "dd5d",
	"./6_de.png": "365b",
	"./7_es.png": "c250",
	"./ai-image.svg": "047b",
	"./avatars/bear.svg": "09c3",
	"./avatars/bull.svg": "3298",
	"./avatars/chicken.svg": "4e28",
	"./avatars/deer.svg": "38aa",
	"./avatars/eagle.svg": "f2e3",
	"./avatars/fox.svg": "f5c9",
	"./avatars/jaguar.svg": "94ce",
	"./avatars/lion.svg": "2b87",
	"./avatars/mouse.svg": "ad26",
	"./avatars/owl.svg": "f90c",
	"./avatars/owl2.svg": "f083",
	"./avatars/tiger.svg": "2d1a",
	"./avatars/wolf.svg": "08bd",
	"./bin.png": "f3e0",
	"./check.png": "7d73",
	"./correct-icon.png": "5520",
	"./facebook-logo.png": "1ebb",
	"./feature-thumbnails/feature-1.jpg": "1228",
	"./feature-thumbnails/feature-10.jpg": "a163",
	"./feature-thumbnails/feature-11.jpg": "0ae8",
	"./feature-thumbnails/feature-12.jpg": "b64e",
	"./feature-thumbnails/feature-2.jpg": "5b18",
	"./feature-thumbnails/feature-3.jpg": "0600",
	"./feature-thumbnails/feature-4.jpg": "97a3",
	"./feature-thumbnails/feature-5.jpg": "fdda",
	"./feature-thumbnails/feature-6.jpg": "92c4",
	"./feature-thumbnails/feature-7.jpg": "450c",
	"./feature-thumbnails/feature-8.jpg": "84de",
	"./feature-thumbnails/feature-9.jpg": "5f77",
	"./flags.png": "9150",
	"./google-logo.png": "bacd",
	"./logo-blue.png": "5fa8",
	"./logo-new.png": "c2c5",
	"./logo-new.webp": "6a27",
	"./logo-red.png": "77ea",
	"./logo.png": "5135",
	"./newsletter.svg": "971b",
	"./no-image.jpg": "f665",
	"./no-image1.png": "e782",
	"./no-image2.png": "a7e1",
	"./no-image3.png": "6fcf",
	"./no-image4.png": "9ea0",
	"./slide1.png": "c5ab",
	"./tbq-skoler.webp": "22c5",
	"./tbq-thumbnail.webp": "4cb5",
	"./tbq-video-thumbnail.jpg": "f458",
	"./thebigquiz.jpg": "23b8",
	"./uncheck.png": "7138",
	"./vipps-logo.png": "ba4e",
	"./wrong-icon.png": "a7c9",
	"./yt-notfound.jpg": "56cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a67";